import React from 'react';

class StateSwitchComponent extends React.Component{
  constructor(props) {
    super(props);
    this.mainSiteComponent = props.mainSiteComponent;
  }

  switchToTable = () => {
    this.mainSiteComponent.setState({view: 'table'});
  }

  switchToSearch = () => {
    this.mainSiteComponent.setState({view: 'search'});
  }
}

export {StateSwitchComponent};
